var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-ticket"},[_c('router-link',{attrs:{"to":_vm.goTo}},[_c('div',{staticClass:"movie-gradient buy",class:{'cancel':_vm.cancel}},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }